import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { CardImage, Text } from '@blueprint/ui';
import { TagWrapper } from '@zoopla/shared/components';
import { CardImagePlaceholder, PropertyImage } from '@zoopla/listings/image';
import { FeatureList } from '@zoopla/listings/features';

export const StyledListingCardMiniTitle = styled(Text)(
    ({ theme: { colors, fontWeight, spacing } }) => css`
        margin-right: ${spacing['24px']};
        line-height: 18px;
        color: ${colors['text-placeholder']};
        font-weight: ${fontWeight.semiBold};
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    `
);

export const StyledListingCardMiniPrice = styled(Text)(
    ({ theme: { type, colors, fontWeight } }) => css`
        font-size: ${type[7]};
        color: ${colors['text-body']};
        font-weight: ${fontWeight.bold};
        line-height: 1;
    `
);

export const StyledMiniCard = styled('div')<{ isSmall: boolean }>(
    ({ isSmall, theme: { colors, spacing, borderRadius, focusRing, type } }) =>
        css`
            text-decoration: none;
            display: inline;
            :focus {
                box-shadow: ${focusRing};
                outline: 0;
            }
            position: relative;
            display: flex;
            flex-direction: row;
            border-radius: ${borderRadius['300']};
            border: solid 1px ${colors['graphic-divider']};
            height: 6.25rem;

            ${TagWrapper} {
                z-index: 1;
                bottom: ${spacing['8px']};
                left: ${spacing['8px']};
                margin: 0;
                max-width: 7rem;
                overflow: hidden;
                position: absolute;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            ${PropertyImage} {
                flex-basis: ${isSmall ? '7.5rem' : '9.375rem'};
                height: 100%;

                ${CardImage}, ${CardImagePlaceholder} {
                    width: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                    margin: 0;
                    height: 100%;
                    object-fit: cover;
                    object-position: center center;
                }
            }

            ${StyledListingCardMiniDetails} {
                flex: 1;
                ${StyledListingCardMiniTitle} {
                    font-size: ${isSmall ? type.small : type.secondary};
                }
            }
        `
);

export const StyledMiniCardLink = StyledMiniCard.withComponent('a');

export const StyledListingCardMiniDetails = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: ${spacing['8px']};
        padding-top: ${spacing['4px']};

        ${StyledListingCardMiniPrice} {
            margin-top: ${spacing['4px']};
        }
        ${FeatureList} {
            margin-top: auto;
            padding-top: ${spacing['4px']};
            padding-bottom: ${spacing['4px']};
            min-width: 10rem;
        }
    `
);

export const StyledListingCardMiniColumn = styled('div')(
    ({ theme: { spacing } }) => css`
        display: flex;
        flex-direction: column;
        ${StyledMiniCard}, ${StyledMiniCardLink} {
            margin: ${spacing['8px']} 0;
        }
    `
);
